export const EventTypes = {
  NEW_MESSAGE: "NEW_MESSAGE",
  MESSAGE_EDITED: "MESSAGE_EDITED",
  MESSAGE_DELETED: "MESSAGE_DELETED",
  REACTION_UPDATED: "REACTION_UPDATED",
  THREAD_COUNT_UPDATED: "THREAD_COUNT_UPDATED",
  NEW_THREAD_REPLY: "NEW_THREAD_REPLY",
  THREAD_REPLY_EDITED: "THREAD_REPLY_EDITED",
  THREAD_REPLY_DELETED: "THREAD_REPLY_DELETED",
  THREAD_REACTION_UPDATED: "THREAD_REACTION_UPDATED",
  TYPING: "TYPING",
  SIDEBAR_NEW_MESSAGE: "SIDEBAR_NEW_MESSAGE",
  GROUP_UPDATED: "GROUP_UPDATED",
  ADDED_TO_GROUP: "ADDED_TO_GROUP",
  REMOVED_FROM_GROUP: "REMOVED_FROM_GROUP",
  UNREAD_UPDATE: "UNREAD_UPDATE",
  HUDDLE_STARTED: "HUDDLE_STARTED",
  HUDDLE_ENDED: "HUDDLE_ENDED",
  HUDDLE_JOINED: "HUDDLE_JOINED",
  HUDDLE_LEFT: "HUDDLE_LEFT",
  HUDDLE_MUTED: "HUDDLE_MUTED",
  HUDDLE_INVITE: "HUDDLE_INVITE",
  HUDDLE_ACTIVE_SPEAKER: "HUDDLE_ACTIVE_SPEAKER",
  PRESENCE_CHANGED: "PRESENCE_CHANGED",
};

export const ReactionAction = {
  ADD: "add",
  REMOVE: "remove",
};

export class EventManager {
  constructor() {
    this.handlers = new Map();
  }

  registerHandler(eventType, handler) {
    if (!this.handlers.has(eventType)) {
      this.handlers.set(eventType, []);
    }
    this.handlers.get(eventType).push(handler);
  }

  unregisterHandler(eventType, handler) {
    if (!this.handlers.has(eventType)) {
      return;
    }
    const handlers = this.handlers.get(eventType);
    const idx = handlers.indexOf(handler);
    if (idx > -1) {
      handlers.splice(idx, 1);
    }
  }

  dispatch(event) {
    if (!event || !event.event) {
      console.warn("dispatch called with invalid event:", event);
      return;
    }
    
    const eventType = event.event;
    const handlers = this.handlers.get(eventType) || [];
    
    if (handlers.length === 0) {
      console.warn("No handlers registered for event type:", eventType);
      return;
    }
    
    handlers.forEach((handler) => {
      try {
        handler(event);
      } catch (err) {
        console.error(`Error in handler for ${eventType}:`, err);
      }
    });
  }

  clear() {
    this.handlers.clear();
  }
}

export const eventManager = new EventManager();
